var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"share-bar__counter\">\n  <span class=\"share-bar__number\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"engagement") : depth0)) != null ? lookupProperty(stack1,"share_count") : stack1), depth0))
    + "</span>\n  <span class=\"share-bar__title\">Compartilharam isso</span>\n</div>\n<div class=\"share-bar__icon\">\n  <i class=\"fas fa-share-alt\"></i>\n</div>\n";
},"useData":true});